import React from "react";
import { ControllerSocket } from "../hooks/socket";

export interface ISocketContext {
  socketWrapper: ControllerSocket | null;
}

export const SocketContext = React.createContext<ISocketContext | undefined>(
  undefined
);
